<template>
  <div class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[1002] p-4 overflow-y-auto">
    <div class="bg-white rounded-xl max-w-lg w-full mx-auto my-auto p-6 shadow-2xl max-h-[90vh] overflow-y-auto">
      <!-- Header -->
      <div class="text-center mb-6">
        <div class="flex justify-center mb-4">
          <div class="bg-blue-100 p-3 rounded-full">
            <span class="material-symbols-outlined text-6xl text-blue-500">diversity_3</span>
          </div>
        </div>
        <h2 class="text-2xl font-bold text-gray-800 mb-2">Join Social Hub</h2>
        <p class="text-gray-600">
          Connect with peers           <span class="material-symbols-outlined text-green-500">check_circle</span>, join study groups <span class="material-symbols-outlined text-green-500">check_circle</span>, and build your academic network .<span class="material-symbols-outlined text-green-500">check_circle</span>
        </p>
      </div>


      <!-- Privacy Note -->
      <div class="bg-blue-50 p-4 rounded-lg mb-6">
        <div class="flex items-start">
          <span class="material-symbols-outlined text-blue-600 mr-3">info</span>
          <div class="text-sm text-gray-700">
            <p class="font-medium text-blue-800 mb-1">Your privacy matters</p>
            <p>
              When you join Social Hub, you make your academic profile visible to other students.
              You control what information you share and can update your preferences anytime.
            </p>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 sticky bottom-0 pt-4 bg-white">
        <button 
          @click="joinSocials"
          class="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition-colors"
          :disabled="loading"
        >
          <span v-if="loading" class="inline-flex items-center">
            <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Joining...
          </span>
          <span v-else>Join Social Hub</span>
        </button>
        <button 
          @click="decline"
          class="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-3 rounded-lg font-medium transition-colors"
          :disabled="loading"
        >
          Not Now
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['joined', 'declined'],
  data() {
    return {
      loading: false
    }
  },
  methods: {
    async joinSocials() {
      this.loading = true;
      try {
        this.$emit('joined');
      } catch (error) {
        console.error("Error joining socials:", error);
      } finally {
        this.loading = false;
      }
    },
    decline() {
      this.$emit('declined');
    }
  }
}
</script>

<style scoped>
/* Fix for iOS Safari to ensure proper scrolling behavior */
@supports (-webkit-touch-callout: none) {
  .fixed {
    position: fixed;
    height: -webkit-fill-available;
  }
}

/* Ensure content fits properly on small devices */
@media (max-height: 700px) {
  .bg-white {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}

/* Improve spacing on very small screens */
@media (max-height: 600px) {
  .space-y-4 > * + * {
    margin-top: 0.75rem;
  }
  
  .mb-6 {
    margin-bottom: 1rem;
  }
  
  .text-6xl {
    font-size: 3rem;
  }
}
</style>
